import { Autocomplete, Button, CircularProgress, TextField } from '@mui/material'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import * as Sentry from "@sentry/react";
import { fetchAllBaskets, getAllBanners, getFinalBannerTemplates } from '../../services/bannerServices'
import { bannerTemplates } from '../createBanner/bannerTemplates';
import { bucketDesigns } from '../createBucket/bucketTypes';
import { openPopup } from "../../stateManagement/actions/popupActions";
import { fetchClientConfig, getClientConfigDomainType, getConfigKeyValue } from '../../services/manageHomeScreenService';
import { retailerAppLayoutConfigObj } from './CreateBlockTypes';
import { fetchAllBuckets } from '../../services/manageBucketService';
import { Banner, BannerTemplate } from '../../types';
import { bucketDesignType } from '../manageBucket/ManageBucketTypes';
import BlockBannerSelection from './BlockBannerSelection';
import { defaultBlockConfig } from '../manageHomepage/ManageHomeScreenConfig';
import { defaultBannerTemplate } from '../createBanner/CreateBanner';
import { Loader } from '../../components/loader/Loader';
import BlockBannerSelectionOld from './BlockBannerSelectionOld';

export default function LinkExistingOld({ blockState, handleParentDataSubmit, validateAllParentInputs, curBlockData, view }: any) {
    const [useBeta, setUseBeta] = useState<boolean>(false);
    const [optionType, setOptionType] = useState<any>([]);
    const [optionTypeValue, setOptionTypeValue] = useState<any>("");
    const [availableValue, setAvailableValue] = useState<string>("");
    const [optionId, setOptionId] = useState<string>("");
    const [optionAvailable, setOptionAvailable] = useState<any[]>([])
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [bodyId, setBodyId] = useState<string>("");
    const [bannerName, setBannerName] = useState<string>("")
    const [banners,setBanners] = useState<Banner[]>([]);
    const clientConfigRef = useRef<any[]>([]);
    const allBlocksRef = useRef<any[]>([]);
    const [compLoader,setCompLoader] = useState<boolean>(false);

    const handleType = (event: any, value: any) => {
        setOptionId(value.id);
        setOptionTypeValue(value);
        setAvailableValue("");
    }

    const handleAvailable = (event: any, value: any) => {
        setBodyId(value.id);
        setBannerName(value.label)
        setAvailableValue(value.label);
    }

    const handleSubmit = async () => {
        try {
            let message = "";
            setShowLoader(true);
            if (validateAllParentInputs) message = validateAllParentInputs();
            if (message !== "") {
                openPopup("Alert", message);
                setShowLoader(false);
                return;
            }
            if (!optionTypeValue) {
                if (blockState?.type !== "Basket") {
                    message = `Please select the ${blockState?.type} type`;
                } 
            }
            // if ( !availableValue) {
            //     if (blockState?.type === "Basket") {
            //         message = `Please select the ${blockState?.type} available options`;
            //     } 
            // }
            if(view!=="create" && blockState.type!=="Banner" && (!availableValue || !bodyId)){
                message = `Please select from the ${blockState?.type} options`;
            }
            // if (view!=="create" && !availableValue) {
            //     if (blockState?.type === "Basket") {
            //         message = `Please select the ${blockState?.type} available options`;
            //     } 
            // }
            if (message !== "") {
                openPopup("Alert", message);
                return;
            }
            let requestBody = {};
            if (blockState?.type === "Banner") {
                const bannerIds = banners.map((bannerObj) => bannerObj.id);
                requestBody = { bannerIds, bannerType: optionId };
            } else if (blockState?.type === "Bucket") {
                // requestBody = { bucketId: bodyId };
                requestBody = (view==="create"? { bucketDesign: optionTypeValue.id } : { bucketDesign: optionTypeValue.id, bucketId: bodyId })
            } else if (blockState?.type === "Basket") {
                // requestBody = { basketId: bodyId };
                requestBody = view ==="create"? { } : { basketId: bodyId };
            }

            handleParentDataSubmit && await handleParentDataSubmit(requestBody);

        } catch (err) {
            openPopup("Alert", "Some error occured")
        } finally {
            setShowLoader(false);
        }
    }
    useEffect(() => {
        async function init(){
            setCompLoader(true);
            const clientconfig = await fetchClientConfig();
            let betaConfig = clientconfig.find((config: any) => {
                return config.domainType === "beta_configuration";
            })?.domainValues;
            const betaBlocks = betaConfig?.find((configObj: retailerAppLayoutConfigObj) => {
                return configObj.name === "homeScreenBlockWidget";
            })?.value ?? [];
            let useBeta = false;
            if (Array.isArray(betaBlocks) && betaBlocks.length > 0) {
                setUseBeta(true);
                debugger;
                useBeta = true;
            }
            const roleAppLayoutConfig = getClientConfigDomainType(clientconfig,"retailer_app_layout_configuration");
            const blockConfig = useBeta ? betaBlocks : getConfigKeyValue(roleAppLayoutConfig,"homeScreenBlockWidget") ?? defaultBlockConfig[0].value;

            clientConfigRef.current = clientconfig;
            allBlocksRef.current = blockConfig;


            if(curBlockData?.id){
                if(curBlockData?.bannerType){
                    const bannerTemplateObj = bannerTemplates.find((bannerTemp) => bannerTemp.id === curBlockData?.bannerType) ?? defaultBannerTemplate;
                    setOptionId(curBlockData?.bannerType);
                    setOptionTypeValue(bannerTemplateObj);
                }
                if(curBlockData?.type==="Bucket" && curBlockData.bucketDesign){
                    const bucketDesignId = curBlockData.bucketDesign;
                    const bucketDesignObj = bucketDesigns.find((bucketDesignOption) => bucketDesignOption.id === curBlockData.bucketDesign);
                    if(bucketDesignObj) setOptionTypeValue(bucketDesignObj);
                    if(bucketDesignId) setOptionId(bucketDesignId);
                } 
            }
            setCompLoader(false);
        }
        init();
        
    },[])

    useEffect(() => {

        const getBasketData = async () => {
            try {
                const basketData = fetchAllBaskets(clientConfigRef.current);
                if(curBlockData?.id && curBlockData?.basketId){
                    const selectedBasket =basketData.find((basketObj: {id: string} ) => basketObj.id === curBlockData.basketId);
                    if(selectedBasket){
                        setBodyId(selectedBasket.id);
                        setAvailableValue(`${selectedBasket.id} - ${selectedBasket.title}`);
                    }
                }
                const blockFilterBasketData = basketData.filter((obj1: { id: any; }) => {
                    return !allBlocksRef.current.some((obj2: { basketId: string }) => obj2.basketId === obj1.id);
                });
                const formattedData = blockFilterBasketData.map((item: { title: string; id: string; }) => ({ label: item.title, id: item.id }));
                const formattedOptions = formattedData.map((option: { id: any; label: any; }) => ({
                    ...option,
                    label: `${option.id} - ${option.label}`
                }));
                setOptionAvailable(formattedOptions);
            } catch (err) {
                // Sentry.captureException(err);
            }
        }

        const getBucketData = async () => {
            try {
                const bucketData = getClientConfigDomainType(clientConfigRef.current,"bucket_configuration");
                if(curBlockData?.id && curBlockData?.bucketId){
                    const selectedBucket = bucketData[0].value.find((bucketObj: {id: string} ) => bucketObj.id === curBlockData.bucketId);
                    if(selectedBucket){
                        setBodyId(selectedBucket.id);
                        setAvailableValue(`${selectedBucket.id} - ${selectedBucket.title}`);
                    }
                }
                const blockFilterBucketData = bucketData[0].value.filter((obj1: { id: any; }) => {
                    return !allBlocksRef.current.some((obj2: { bucketId: string }) => obj2.bucketId === obj1.id);
                });
                const filteredBucketData = blockFilterBucketData.filter((item: { bucketDesign: string; }) => item.bucketDesign === optionId);
                const formattedData = filteredBucketData.map((item: { title: string; id: string; }) => ({ label: item.title, id: item.id }));
                const formattedOptions = formattedData.map((option: { id: any; label: any; }) => ({
                    ...option,
                    label: `${option.id} - ${option.label}`
                }));
                setOptionAvailable(formattedOptions);
            } catch (err) {
                // Sentry.captureException(err);
            }
        }

        const getBannerData = async () => {
            try {
                const clientconfig = clientConfigRef.current;
                const allBlocks = allBlocksRef.current;
                const bannerData: any[] = await getAllBanners();
                const bannerIdSet = new Set();
                const templateFilteredBanners = bannerData.filter(item => item.bannerType === optionId);
                allBlocks.forEach((blockObj: any) => {
                   blockObj?.bannerIds?.forEach((id: string) => {
                    bannerIdSet.add(id);
                   })
                })
                const blockFilterBannerData = templateFilteredBanners.filter(bannerObj => {
                    return !bannerIdSet.has(bannerObj.id);
                })
                const formattedData = blockFilterBannerData.map(item => ({ label: item.bannerName, id: item.id }));
                setOptionAvailable(formattedData)
            } catch (err) {
                // Sentry.captureException(err);
            }
        }
        if(clientConfigRef.current.length){
            // { blockState?.type === "Banner" && getBannerData() }
            { blockState?.type === "Bucket" && getBucketData() }
            { blockState?.type === "Basket" && getBasketData() }
        }
    }, [clientConfigRef.current,optionId, blockState?.type])

    useEffect(() => {
        if(clientConfigRef.current.length){
            if (blockState?.type === "Banner") {
                const tempBannerTemplates = getFinalBannerTemplates(clientConfigRef.current);
                const finalBannerTemplates = tempBannerTemplates.filter((bannerTemp) => bannerTemp.id !== "template34");
                setOptionType(finalBannerTemplates)
            }
            if (blockState?.type === "Bucket") {
                setOptionType(bucketDesigns)
            }
        }
        if(view==="create"){
            setOptionTypeValue("")
            setAvailableValue("")
            setOptionId("")
        }
    }, [clientConfigRef.current,blockState?.type])
    // console.log("optionAvailable:", optionAvailable)
    // console.log("optionType:", optionType)
    const selectedBannerTemplates = useMemo(() => {
        return curBlockData?.bannerType? [curBlockData.bannerType]: [optionId];
    },[optionId,curBlockData?.bannerType])

    const isAvailableOptionDisabled = useMemo(() => {
        if(view!=="create" && curBlockData?.id && curBlockData?.type){
            switch(curBlockData.type){
                case "Bucket": {
                    if(curBlockData?.id && curBlockData?.bucketId){
                        const bucketData = getClientConfigDomainType(clientConfigRef.current,"bucket_configuration");
                        const selectedBucket = bucketData?.[0]?.value?.find((bucketObj: {id: string} ) => bucketObj.id === curBlockData.bucketId);
                        return Boolean(selectedBucket?.id)
                    }
                    return false;
                }
                case "Basket": {
                    if(curBlockData?.id && curBlockData?.basketId){
                        const basketData = fetchAllBaskets(clientConfigRef.current);
                        const selectedBasket = basketData?.find((basketObj: {id: string} ) => basketObj.id === curBlockData.basketId);
                        return Boolean(selectedBasket?.id);
                    }
                    return false;
                }
            }
        }
        return false;
    },[curBlockData,clientConfigRef.current])

    return (
        <>
           {compLoader? <Loader /> : (<div className="create-basket-parent">
                <div className="create-basket-label">
                    <span>{blockState?.type ? blockState?.type : ""}</span>
                </div>
                <div className="create-basket-input-fields">
                    {blockState?.type !== "Basket" && <>
                        <label className="create-block-input-labels">{blockState?.type.toUpperCase()} TYPE SELECTION </label>
                        <Autocomplete
                            disableClearable
                            sx={{ width: "100%" }}
                            options={optionType}
                            getOptionLabel={(option: any) => {
                               return (option).displayName ?? option.label ?? ""
                            }}
                            disabled={view==="edit"}
                            value={optionTypeValue}
                            onChange={handleType}
                            size="small"
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder={`Select ${blockState?.type} Type`}
                                />
                            )}
                        />
                    </>}
                    {view!=="create" && blockState?.type!=="Banner" && <><label className="create-block-input-labels">AVAILABLE {blockState?.type?.toUpperCase()}</label>
                    <Autocomplete
                        disableClearable
                        sx={{ width: "100%" }}
                        disabled={isAvailableOptionDisabled}
                        options={optionAvailable}
                        value={availableValue}
                        onChange={handleAvailable}
                        // getOptionLabel={(option) => blockState?.type !== "Banner" ? `${option.id}-${option.label}` : option.label}
                        size="small"
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                placeholder={`Select from Availabe ${blockState?.type}`}
                            />
                        )}
                    /></>}
                </div>
                {view!=="create" && blockState?.type==="Banner" && optionTypeValue && clientConfigRef.current.length && <div className='create-block-input-fields'><BlockBannerSelectionOld label='SELECT BANNERS' allBlocks={allBlocksRef.current} bannerIds={curBlockData?.bannerIds} banners={banners} setBanners={setBanners} bannerTemplates={selectedBannerTemplates} view={view} /></div>}
                <button
                    className="create-basket-submit create-basket-submit-active"
                    onClick={handleSubmit}
                >
                    {showLoader ? (
                        <div>
                            <CircularProgress size={15} color="inherit" />
                            <span className="circular-progress-container ">SUBMIT</span>
                        </div>
                    ) : (
                        <>SUBMIT</>
                    )}
                </button>
            </div>)}

        </>
    )
}